import { useLayoutEffect, useRef } from 'react'

/** @param {boolean} open @param {HTMLElement | null} anchorEl @param {boolean} restoreFocusOnClose */
export function useFloatingMenuFocusRestore(open, anchorEl, restoreFocusOnClose) {
  const lastAnchorRef = useRef(/** @type {HTMLElement | null} */ (null))
  const wasOpenRef = useRef(false)

  useLayoutEffect(() => {
    if (open && anchorEl instanceof HTMLElement) lastAnchorRef.current = anchorEl
    if (wasOpenRef.current && !open && restoreFocusOnClose) {
      const el = lastAnchorRef.current
      if (el && typeof el.focus === 'function' && document.documentElement.contains(el)) {
        requestAnimationFrame(() => el.focus({ preventScroll: true }))
      }
    }
    wasOpenRef.current = open
  }, [open, anchorEl, restoreFocusOnClose])
}
